var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5C5.06055 0.5 6.07813 0.921875 6.828 1.67188C7.57788 2.42188 7.99988 3.43945 7.99988 4.49988V5.49988H5.99988V4.49988C5.99988 3.39538 5.10438 2.49988 3.99988 2.49988C2.89538 2.49988 1.99988 3.39538 1.99988 4.49988V12.4999C1.99988 13.6044 2.89538 14.4999 3.99988 14.4999C5.10438 14.4999 5.99988 13.6044 5.99988 12.4999V11.4999H7.99988V12.4999C7.99988 13.9286 7.23718 15.2499 5.99988 15.9636C4.76258 16.6785 3.23713 16.6785 1.99988 15.9636C0.762576 15.2498 -0.000123978 13.9285 -0.000123978 12.4999V4.49988C-0.000123978 3.43933 0.421751 2.42175 1.17175 1.67188C1.92175 0.922 2.93958 0.5 4 0.5Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99998 7.50001H12.585L10.585 5.50001L12 4.08496L15.707 7.79296C15.8955 7.98046 16.001 8.23436 16.001 8.49999C16.001 8.76561 15.8955 9.01951 15.707 9.20701L12 12.915L10.585 11.5L12.585 9.49996H3.99998V7.50001Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.97043a66d68793c6127dd8a99a01b55a.svg";
export { ForwardRef as ReactComponent };